const STYLES: Record<string, { bg: string; fg: string; label: string }> = {
  starter: { bg: "#2a2a2a", fg: "#cfcfcf", label: "Starter" },
  pro: { bg: "#0D7680", fg: "#e6fbff", label: "Pro" },
  agency: { bg: "#C8A84B", fg: "#1a1206", label: "Agency" },
  teardown: { bg: "#3a342a", fg: "#e6dfd1", label: "Teardown" },
};

export function PlanBadge({ planId, planName }: { planId: string; planName?: string }) {
  const key = planId.toLowerCase();
  const match = Object.entries(STYLES).find(([k]) => key.includes(k));
  const s = match ? match[1] : { bg: "#2a2a2a", fg: "#cfcfcf", label: planName ?? planId };
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em]"
      style={{ backgroundColor: s.bg, color: s.fg }}
    >
      {s.label}
    </span>
  );
}
